import AppointmentCard from "./AppointmentCard";
import RouteColumn from "./RouteColumn";
import TechnicianHeader from "./TechnicianHeader";
import StatusIndicator from "./StatusIndicator";

const defaultRegistry = {
  AppointmentCard,
  RouteColumn,
  TechnicianHeader,
  StatusIndicator,
  // Which schedule surface a vertical lands on. Route-dense daily ops (pest)
  // default to the DAY board; job-shaped trades think in weeks/months and
  // default to the jobs MONTH planner.
  defaultScheduleView: "day",
  // Board PRESENTATION preset (one board component, presentation config over it):
  //   dense    — 30-min pill grid (pest/FR): many short stops
  //   blocks   — duration-proportional job blocks (landscaping/lawn): few long jobs
  //   projects — multi-hour/day spanning blocks (construction/roofing)
  boardPreset: "dense",
};

const registries = {
  default: defaultRegistry,
  pest_control: defaultRegistry,
  landscaping: { ...defaultRegistry, defaultScheduleView: "month", boardPreset: "blocks" },
  lawn: { ...defaultRegistry, defaultScheduleView: "month", boardPreset: "blocks" },
  construction: { ...defaultRegistry, defaultScheduleView: "month", boardPreset: "projects" },
  roofing: { ...defaultRegistry, defaultScheduleView: "month", boardPreset: "projects" },
  general: defaultRegistry,
  events: { ...defaultRegistry, boardPreset: "blocks" },
};

export const getDispatchRegistry = (industryKey = "default") =>
  registries[String(industryKey || "default").toLowerCase()] || defaultRegistry;

export const getDefaultScheduleView = (industryKey = "default") =>
  getDispatchRegistry(industryKey).defaultScheduleView || "day";

export const getBoardPreset = (industryKey = "default") =>
  getDispatchRegistry(industryKey).boardPreset || "dense";
